"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var TextField_1 = __importDefault(require("../../TextField"));
var Button_1 = __importDefault(require("../../Button"));
var editor_web_1 = require("@21st-night/editor-web");
exports.useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        root: {},
    });
});
var StudyPlanShareModal = function (_a) {
    var classNameProp = _a.className, children = _a.children, description = _a.description, title = _a.title, onChangeTitle = _a.onChangeTitle, onChangeDescription = _a.onChangeDescription, onClickCancel = _a.onClickCancel, onSubmit = _a.onSubmit, dialogTitle = _a.dialogTitle, submitButtonLabel = _a.submitButtonLabel, other = __rest(_a, ["className", "children", "description", "title", "onChangeTitle", "onChangeDescription", "onClickCancel", "onSubmit", "dialogTitle", "submitButtonLabel"]);
    var _b = __read(react_1.useState(description ? JSON.parse(description) : editor_web_1.generateRichTextDocument()), 2), value = _b[0], setValue = _b[1];
    var classes = exports.useStyles();
    function handleChangeDescription(newValue) {
        setValue(newValue);
        onChangeDescription(newValue);
    }
    return (react_1.default.createElement(core_1.Dialog, __assign({ fullWidth: true, maxWidth: "sm", className: clsx_1.default(classes.root, classNameProp) }, other),
        react_1.default.createElement("form", { onSubmit: onSubmit },
            react_1.default.createElement(core_1.DialogTitle, null, dialogTitle || 'Share study plan'),
            react_1.default.createElement(core_1.DialogContent, null,
                react_1.default.createElement(TextField_1.default, { fullWidth: true, margin: "normal", label: "Title", variant: "underlined", name: "title", id: "study-plan-title", value: title, onChange: onChangeTitle }),
                react_1.default.createElement(core_1.Typography, { style: { marginTop: 24 } }, "Description"),
                react_1.default.createElement(editor_web_1.Editor
                // placeholder="Add an optional description"
                // toolbar={['bold', 'underline', 'italic', 'strikethrough']}
                , { 
                    // placeholder="Add an optional description"
                    // toolbar={['bold', 'underline', 'italic', 'strikethrough']}
                    onChange: handleChangeDescription, value: value }),
                children),
            react_1.default.createElement(core_1.DialogActions, null,
                react_1.default.createElement(Button_1.default, { onClick: onClickCancel }, "Cancel"),
                react_1.default.createElement(Button_1.default, { type: "submit", variant: "contained", color: "primary" }, submitButtonLabel || 'Share')))));
};
exports.default = StudyPlanShareModal;
//# sourceMappingURL=StudyPlanShareModal.js.map